import { ICompany, Pagination } from '@getgreenline/homi-shared'
import { InventoryLogAPI } from '@getgreenline/inventory'
import {
  IInventoryLogFilter,
  IInventoryLog,
} from '@getgreenline/inventory/build/models/inventoryLog'
import { observable, computed } from 'mobx'
import { message } from 'antd'
import { parseErrorMsg } from '../../../../../../utilities/helpers'
import { dayjs } from '../../../../../../utilities/dayjs'

export class InventoryLogStore {
  constructor(
    private company: ICompany,
    productId: string,
    locationId: number,
    public inventoryLogFilter: IInventoryLogFilter = {
      limit: 50,
      offset: 0,
      categoryIds: [],
      employeeIds: [],
      notesQuery: '',
    },
  ) {
    this.inventoryLogFilter.productIds = [productId]
    this.inventoryLogFilter.locationId = locationId
  }

  @observable logs: IInventoryLog[] | undefined
  @observable isLoading = false
  @observable pastWeekInventoryLogs?: IInventoryLog[]
  @observable pagination = new Pagination(this.inventoryLogFilter)

  @computed get isLastPage() {
    if (this.inventoryLogFilter.limit) {
      return (
        (this.logs || []).length === 0 || (this.logs || []).length < this.inventoryLogFilter.limit
      )
    }
  }

  getInventoryLogs = async () => {
    try {
      this.isLoading = true

      const response = await InventoryLogAPI.getInventoryLogs(
        this.company.id,
        this.inventoryLogFilter,
      )
      this.logs = response.data
    } catch (error) {
      message.error(parseErrorMsg(error) || 'Unable to get latest inventory logs')
    } finally {
      this.isLoading = false
    }
  }

  getInventoryGraphLogs = async () => {
    const inventoryLogs = await InventoryLogAPI.getInventoryLogs(this.company.id, {
      ...this.inventoryLogFilter,
      startDate: dayjs().subtract(14, 'days').toDate(),
      endDate: new Date(),
    })
    // Inventory logs come newest > oldest. Reverse for graphing purposes
    this.pastWeekInventoryLogs = inventoryLogs.data.reverse()
  }
}
